import { render, staticRenderFns } from "./product-delivery.vue?vue&type=template&id=4d0b651e&"
import script from "./product-delivery.vue?vue&type=script&lang=js&"
export * from "./product-delivery.vue?vue&type=script&lang=js&"
import style0 from "./product-delivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0b651e')) {
      api.createRecord('4d0b651e', component.options)
    } else {
      api.reload('4d0b651e', component.options)
    }
    module.hot.accept("./product-delivery.vue?vue&type=template&id=4d0b651e&", function () {
      api.rerender('4d0b651e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-delivery.vue"
export default component.exports